import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-overline-size leading-4 font-semibold uppercase tracking-[0.045em] whitespace-nowrap shrink-0 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background",
  {
    variants: {
      variant: {
        default:
          "border-primary/25 bg-primary/12 text-primary",
        secondary: "border-border/70 bg-muted/75 text-muted-foreground",
        destructive:
          "border-destructive/25 bg-destructive/12 text-destructive",
        outline: "text-muted-foreground border-border/80 bg-surface-subtle/40 font-medium",
        success:
          "border-success/25 bg-success/12 text-success",
        warning:
          "border-warning/25 bg-warning/12 text-warning",
        info: "text-info bg-info/10 border-info/20",
        violet:
          "border-primary/25 bg-primary/12 text-primary",
        purple:
          "border-primary/25 bg-primary/12 text-primary",
        indigo:
          "border-primary/25 bg-primary/12 text-primary",
        blue: "text-info bg-info/10 border-info/20",
        emerald:
          "border-success/25 bg-success/12 text-success",
        amber:
          "border-warning/25 bg-warning/12 text-warning",
        rose: "border-destructive/25 bg-destructive/12 text-destructive",
        teal: "border-success/25 bg-success/12 text-success",
        orange:
          "border-warning/25 bg-warning/12 text-warning",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({ className, variant, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
